import React from 'react';

export function SearchIcon () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.006 14.558A6.713 6.713 0 105.754 2.2a6.713 6.713 0 005.252 12.357zM13.126 13.126l5.207 5.207"
      />
    </svg>
  );
}
